import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/dashboard',
    name: 'dashboard-home',
    component: () => import('@/views/dashboard/Index.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_HOME,
      action: 'read',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard-statistics',
    component: () => import('@/views/dashboard/home/IndividualDashboard.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_HOME,
      action: 'read',
    },
  },
  {
    path: '/dashboard/basic-reporting',
    name: 'dashboard-basic-reporting',
    component: () => import('@/views/dashboard/basic-reporting/BasicReporting.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_BUSINESS_METRICS,
      action: 'read',
      pageTitle: 'Business Metrics',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Dashboards',
        },
        {
          text: 'Business Metrics',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/worker-performance',
    name: 'dashboard-worker-performance',
    component: () => import('@/views/dashboard/leader-board/WorkerPerformance.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_LEADER_BOARD,
      action: 'read',
      pageTitle: 'Leader Board',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Dashboards',
        },
        {
          text: 'Leader Board',
          active: true,
        },
      ],
    },
  },
]
